import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import {useNavigate} from "react-router-dom";



import "./pricing.css";

const plans = [
  {
    title: "Started",
    points: [
      "No setup headaches, just log in and go!",
      "Presets insights on visible demand",
      "Businesses that want quick deployment",
      "Subscription-Based",
    ],
  },
  {
    title: "Growth",
    points: [
      "Customised Insights",
      "AI-powered APIs and frameworks to customize as you wish",
      "Businesses that want control, minus the extra work.",
      "Pay-as-you-Grow",
    ],
  },
  {
    title: "Pro",
    points: [
      "ERP Integration Or Custom Insights + UI",
      "AI-powered APIs and frameworks to customize as you wish",
      "Businesses that want control, minus the extra work.",
      "Project-Based",
    ],
  },
  {
    title: "Master",
    points: [
      "Fully customized to match your industry needs",
      "Deep system integration",
      "Fully tailored AI at scale",
      "Project-Based",
    ],
  },
];

const faqData = {
  insights: [
    {
      question: "How do I access historical data?",
      answer: "You can easily view past data right from your dashboard...",
    },
    {
      question: "Is it compatible with my existing CCTV system?",
      answer: "Yes! Argus works with most standard IP cameras...",
    },
    {
      question: "Can it work in multiple locations or just one site?",
      answer: "It supports both. Whether you have a single warehouse...",
    },
    {
      question: "Does it send notifications in real time or after the event?",
      answer: "Notifications are sent in real time...",
    },
  ],
  access: [
    {
      question: "Can I set roles or permissions for my team?",
      answer: "Yes. Argus uses Role-Based Access Control (RBAC)...",
    },
    {
      question: "Who can access the information?",
      answer: "Only authorized users can access Argus...",
    },
    {
      question: "Will I get notified instantly if something happens?",
      answer: "Yes. Argus sends real-time alerts...",
    },
  ],
  reports: [
    {
      question: "Does Argus give me reports or just visuals?",
      answer: "You can get reports showing vehicle activity...",
    },
    {
      question: "Can I track performance over time?",
      answer: "Yes! Argus helps you spot patterns...",
    },
  ],
  setup: [
    {
      question: "Does it work with my existing setup?",
      answer: "Yes, Argus is designed to plug into your existing systems...",
    },
    {
      question: "How easy is it to install or configure?",
      answer: "Very easy. Most of the setup is plug-and-play...",
    },
  ],
};

export default function Pricing() {
  const navigate =useNavigate()
  const [activeTab, setActiveTab] = useState("insights");
  const [openQuestion, setOpenQuestion] = useState(null);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setOpenQuestion(null);
  };

  const toggleQuestion = (index) => {
    setOpenQuestion(openQuestion === index ? null : index); 
  };

  return (
    <>
      <div>
      <Navbar />
      <div className="spacer"></div>

        {/* Pricing Section */}
        <section className="pricing-section">
          <h1>Choose Your Plan</h1>
          <p>Plans built for growth — start small, scale fast.</p>
          <div className="plans">
            {plans.map((plan, index) => (
              <div className="plan-card" key={index}>
                <div className="plan-title">{plan.title}</div>
                {plan.points.map((pt, i) => (
                  <p key={i}>{pt}</p>
                ))}
                <a onClick={()=>{navigate('/Demo')}} className="start-button">
                  Start Now
                </a>
              </div>
            ))}
          </div>
        </section>

        {/* FAQ Section */}
        <section className="faq-section">
          <h2>Frequently asked questions</h2>
          <div className="faq-tabs">
            {Object.keys(faqData).map((tab) => (
              <button
                key={tab}
                className={`faq-tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => handleTabClick(tab)}
              >
                {tab.charAt(0).toUpperCase() +
                  tab.slice(1).replace(/([A-Z])/g, " $1")}
              </button>
            ))}
          </div>

          <div className="faq-content active">
            {faqData[activeTab].map((item, index) => (
              <div className="faq-item" key={index}>
                <button
                  className={`faq-question ${
                    openQuestion === index ? "open" : ""
                  }`}
                  onClick={() => toggleQuestion(index)}
                >
                  {item.question}
                </button>
                <div
                  className="faq-answer"
                  style={{ display: openQuestion === index ? "block" : "none" }}
                >
                  {item.answer}
                  <div className="linkedin-link">
                    <a
                      href="https://www.linkedin.com/company/ekakinn/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="linkedin-icon"
                        src="https://cdn-icons-png.flaticon.com/512/174/174857.png"
                        alt="LinkedIn"
                      />
                    </a>
                  </div>
                </div>  
              </div>
            ))}
          </div>
        </section>
       
        

      </div>

      <Footer />
    </>
  );
}
